import apiClient from "../common/apiClient";
import Config from "../common/Config";
import FieldState from "../common/FieldState";
import OrderFormStep from "../common/OrderFormStep";
import FormTitle from "../components/formTitle/FormTitle";
import MuiRadio from "../components/radio/MuiRadio";
import MuiCheckbox from "../components/checkbox/MuiCheckbox";
import InputTextField from "../components/textField/InputTextField";
import MuiDatePicker from "../components/datePicker/MuiDatePicker";
import Button from "../components/button/Button";
import SecondaryButton from "../components/button/SecondaryButton";
import { CreateNotification } from "../components/notification/Notification";
import SaveAsDraft from "../components/modal/SaveAsDraft";
import ClearOrder from "../components/modal/ClearOrder";
import "react-datepicker/dist/react-datepicker.css";
import TextField from '@material-ui/core/TextField';
import {
  Alert,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

export default class KneeSelection extends OrderFormStep {
  constructor(props) {
    super(props);


    this.state = {
      isSubmit: false,
      knees: [],
      formState: {
        knee: new FieldState(true),
      },
    };
  }

  loadCart() {
    let cart = [];

    let addToCart = (options, selectedId, sourceId) => {
      let item = options.filter(x => x.id===selectedId)[0];
      if(item && item.partNumbers && item.partNumbers.length > 0) {
        item.partNumbers.forEach(part => {
          cart.push({
            name: item.displayName,
            partNumber: part,
            quantity: 1,
            price: -1,
            sourceId: sourceId
          });
        });
      } else {
        cart.push({
            name: null,
            partNumber: null,
            quantity: 0,
            price: 0,
            sourceId: sourceId
          });
      }
    }

    addToCart(this.state.knees, this.state.formState.knee.value, "knee");

    let config = {};
    config.params = {
      cart: cart.map(x => x.partNumber)
    }

    return apiClient.get("price/" + this.props.formTypeId +"/",
      config
    ).then(response => {
      let data = response.data

      cart = cart.map(c => {
        return {
          name: c.name,
          partNumber: c.partNumber,
          quantity: c.quantity,
          price: data.filter(x => x.partNumber === c.partNumber)[0]?.price,
          sourceId: c.sourceId
        }
      });

      cart = cart.concat(data.filter(d => d.sourceId !== null).map(d => {
        return {
          name: d.name,
          partNumber: d.partNumber,
          quantity: d.quantity,
          price: d.price,
          sourceId: d.sourceId
        }
      }));
      
      this.props.setTempCart(cart);
    }).catch(error =>{
      console.log(error)
    });
  }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {
      this.setState({
        knees: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "knee" },
            }
          )
        ).data,
      });


      let config = {
        params: {
          fieldNames: [
            "knee",
          ],
        },
      };

      const { data } = await apiClient.get("fieldInputs/" + this.props.formTypeId,
        config
      );
      let formState = this.state.formState;
      formState.knee.value = data.find(
        (fi) => fi.fieldName === "knee"
      )?.fieldOptionId;



      this.setState({
        formState: formState,
      });

      this.loadCart();
    

    this.setState({ isLoaded: true });
  }

  saveData() {

    let data = [];

    data.push({
      fieldName: "knee",
      fieldOptionId: this.state.formState.knee.value,
    });



    if (this.validateData().isValid) {
      return apiClient.post("fieldInputs/" + this.props.formTypeId,
        data
      );
    } else {
      this.setState({
        isSubmit: true,
      });
      CreateNotification(this.validateData().errorMessage, "error");

      return;
    }
  }

  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id].isRequired &&
      (formState[id].value === "" ||
        formState[id].value === 0 ||
        formState[id].value === null);
    return errorClass ? true : false;
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();

    return (
      <>
        <div className="checkFormWrapper">
          <FormTitle
            title="Product Information"
            description=""
          />

          <form className="checkform" onSubmit={e => {e.preventDefault()}}>
            <div className="fieldBorder">
                <MuiRadio
                  options={this.state.knees}
                  defaultValue={this.state.formState.knee.value}
                  label="Knee Selection"
                  required={this.state.formState["knee"].isRequired}
                  error={this.handleError("knee") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "knee");
                  }}
                />
              </div>

          </form>
        </div>

        <div className="handelButtons">
          <SecondaryButton
            text="Save As Draft"
            onClick={this.props.handleClickOpen}
          />
          <SecondaryButton
            text = "Clear the Order?"
            onClick = {this.props.handleClickClearOpen}
          />               
          <div className="stepBtn">
            <SecondaryButton
              text="Back"
              onClick={() => this.props.handleBack(this.props.currentIndex - 1)}
              disabled={
                this.props.activeOuterStep === 0 && this.props.innerStep === 0
              }
            />
            <Button
              text="Next"
              disabled={this.state.isLoading}
              onClick={async () => {
                try {
                  this.setState({ isLoading: true });
                  const res = await this.saveData();
                  if (res.status === 204) {
                    this.props.handleNext(3);
                    this.setState({ isLoading: false });
                  }
                } catch (err) {
                  this.setState({ isLoading: false });
                }
              }}
            />
          </div>
        </div>
        <SaveAsDraft
          open={this.props.open}
          handleClose={this.props.handleClose}
          showSubmit={this.props.showSubmit}
          setShowSubmit={this.props.setShowSubmit}
        />
        <ClearOrder
          openClear={this.props.openClear}
          handleCloseClear={this.props.handleCloseClear}
          showClear={this.props.showClear}
          setShowClear={this.props.setShowClear}
          formId = {this.props.formTypeId}
          handleClearBack={this.props.handleClearBack}
        />           
      </>
    );
  }
}